const CONFIRMS = {
    CONFIRMAR_REGISTRO: "¿Está seguro de que la información suministrada es correcta?"
}

export default CONFIRMS